import { Component, Input, OnInit } from "@angular/core";
import { FieldBase } from "./model/field-base.model";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "src/app/core/services/common.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";

@Component({
  selector: "app-form-fields",
  templateUrl: "./form-fields.component.html",
  styleUrls: ["./form-fields.component.scss"],
})
export class FormFieldsComponent implements OnInit {
  @Input() fields: FieldBase<any>[];

  public form: FormGroup;

  constructor(
    private commonService: CommonService,
    private toastrAlertService: ToastrAlertService
  ) {}

  ngOnInit(): void {
    this.form = this.initForm();
  }

  public initFormWithData(fields: FieldBase<any>[]) {
    this.fields = fields;
    this.form = this.initForm();
  }

  private initForm() {
    const group: any = {};
    let fieldsWithControlName = this.fields.filter(
      (field) => field.formControlName !== null
    );
    fieldsWithControlName.forEach((field) => {
      const validators: any[] = [];

      if (field.required) {
        validators.push(Validators.required);
      }

      if (field.validators && field.validators.length > 0) {
        validators.push(...field.validators);
      }
      if (field.disabled) {
        group[field.formControlName] =
          validators.length > 0
            ? new FormControl(
                { value: field.value, disabled: true },
                validators
              )
            : new FormControl({ value: field.value, disabled: true });
      } else {
        group[field.formControlName] =
          validators.length > 0
            ? new FormControl(field.value, validators)
            : new FormControl(field.value);
      }
    });
    return new FormGroup(group);
  }

  public getForm() {
    if (this.form.invalid) {
      let invalidFields = this.commonService.findInvalidControls(
        this.form.controls
      );
      if (invalidFields.length > 0) {
        let text = this.commonService.getValueOfLabelsById(invalidFields);
        this.toastrAlertService.toastrFail(text);
      }
      return null;
    } else {
      return this.form;
    }
  }

  public getSelectorVisibleValue(field) {
    if (field.selectorItem == null) return null;
    return field.selectorItem[field.selectorFields[1]];
  }

  public changeValueOfForm(event: any, field: FieldBase<any>) {
    this.form.patchValue({
      [field.formControlName]: event.item[event.id],
    });
    field.selectorSendValue(event);
  }

  getCombinedStyles(field: any): { [key: string]: string } {
    return {
      ...field.style,
      width: field.label === 'Nuevo comentario' ? '100%' : '266px',
      overflow: 'hidden',
    };
  }

  public autoExpand(event: any): void {
    let element = event.target;
    element.style.height = "5px";
    element.style.height = element.scrollHeight + "px";
}
}
